import { t } from 'i18next'

import {
  ErrorStatusModel,
  FieldDetails,
  ResourceDetails,
} from '../../types/exception/errorStatus'

export const getErrorMessage = (error: ErrorStatusModel): string => {
  if (!error.messageKey) {
    return t('exceptions:unknown')
  }

  switch (error.status) {
    case 400: {
      const details = error.details as FieldDetails

      if (details.value === 'profile-details-incomplete') {
        return t('exceptions:profile-details-incomplete')
      }

      return t(`exceptions:${error.messageKey}`, {
        value: details.value,
        field: details.field,
      })
    }

    case 401: {
      return t(`exceptions:${error.messageKey}`)
    }

    case 403: {
      return t(`exceptions:${error.messageKey}`)
    }

    case 404: {
      const details = error.details as ResourceDetails
      return t(`exceptions:${error.messageKey}`, {
        resource: details.resource,
        value: details.value,
      })
    }

    case 409: {
      // Conflicts may carry extra values for their message (e.g. which rule overlaps, and where); weekday lists are
      // sent as day names and shown as short labels.
      const details = error.details as ResourceDetails & Record<string, unknown>
      const days = Array.isArray(details.days)
        ? (details.days as string[]).map(day => t(`common:days-short.${day.toLowerCase()}`)).join(', ')
        : undefined
      return t(`exceptions:${error.messageKey}`, {
        ...details,
        days,
        resource: details.resource,
        value: details.value,
      })
    }
  }

  return t(`exceptions:${error.messageKey}`)
}
